<template>
  <div class="phone-edit">
    <ui-input
      :value="phone"
      readonly
      mask="phone"
      :validate="['required', 'phone']"
      class="input"
      label="Телефон*"
      placeholder="Укажите ваш телефон"
    >
      <div
        class="edit-icon"
        slot="append"
        @click="phoneEditOpened = true"
      >
        <f-sprite-icon :icon-link="$options.icons.IconEdit.id" />
      </div>
    </ui-input>

    <modal
      :visible="phoneEditOpened"
      @on-close="phoneEditOpened = false"
    >
      <phone-edit-modal
        @on-close="phoneEditOpened = false"
        @change="phone = $event"
      />
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PhoneEditModal from '@/components/account/phone-edit-modal';
/* Icons */
import IconEdit from '@icons/edit.svg';

export default {
  name: 'phone-edit',

  icons: {
    IconEdit
  },

  components: {
    PhoneEditModal,
  },

  data: () => ({
    phone: '',
    phoneEditOpened: false, // модалка
  }),

  computed: {
    ...mapGetters({
      ACCOUNT: 'user/account',
    }),
  },

  created() {
    this.phone = this.ACCOUNT.phone;
  },
}
</script>
